export const INDUSTRY_TYPES = [
  '专项债类',
  '设备采购类',
  '新建工程类',
  '重建改造类',
  '服务采购类',
  '工作经费类',
  '公共卫生类',
  '技能培训类',
  '城市运营类',
  '信息化建设类',
  '政策补助类'
];

export const CLIENT_LEVELS = [
  '省级',
  '市级',
  '县区级'
];

export const PROJECT_STATUSES = [
  { value: 'draft', label: '草稿', color: 'default' },
  { value: 'active', label: '进行中', color: 'primary' },
  { value: 'completed', label: '已完成', color: 'success' },
  { value: 'archived', label: '已归档', color: 'secondary' }
];

export const USER_ROLES = [
  { value: 'user', label: '普通用户' },
  { value: 'admin', label: '管理员' },
  { value: 'super_admin', label: '超级管理员' },
  { value: 'zhaoyuan_admin', label: '昭远管理员' }
];
